import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token em memória para acesso imediato
let memoryToken: string | null = null;

// Função para definir o token em memória
export const setMemoryToken = (token: string | null) => {
  console.log('[API] setMemoryToken chamado:', {
    hasToken: !!token,
    tokenPreview: token?.substring(0, 20)
  });
  memoryToken = token;
};

// Interceptor para adicionar token JWT
api.interceptors.request.use((config) => {
  // Debug: forçar visualização
  const debugInfo = {
    url: config.url,
    hasMemoryToken: !!memoryToken,
    memoryTokenPreview: memoryToken?.substring(0, 20),
  };
  
  // Prioridade 1: Token em memória (mais rápido)
  if (memoryToken) {
    config.headers.Authorization = `Bearer ${memoryToken}`;
    console.log('[API] Token adicionado do memoryToken', debugInfo);
    return config;
  }
  
  // Prioridade 2: Token do sessionStorage
  const authStorage = sessionStorage.getItem('auth-storage');
  if (authStorage) {
    try {
      const { state } = JSON.parse(authStorage);
      if (state?.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
        // Sincroniza com memória para próximas requisições
        memoryToken = state.token;
        console.log('[API] Token adicionado do sessionStorage', debugInfo);
      } else {
        console.warn('[API] Token não encontrado no state', debugInfo);
      }
    } catch (e) {
      console.error('[API] Erro ao parsear authStorage', e);
    }
  } else {
    console.warn('[API] sessionStorage vazio', debugInfo);
  }
  
  return config;
});

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const backendError = String(error.response?.data?.error || '').toLowerCase();
      const shouldInvalidateSession =
        backendError.includes('token') ||
        backendError.includes('não autenticado') ||
        backendError.includes('nao autenticado');

      // Só invalida sessão quando o backend confirma problema de autenticação/token.
      if (shouldInvalidateSession) {
        memoryToken = null;
        sessionStorage.removeItem('auth-storage');
        // Redireciona para login se não estiver já na página de login
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/admin/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
